import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d0c191"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tir-pm-multiselect__area-left-slot"
}
const _hoisted_2 = { class: "tir-pm-multiselect__desc-select" }
const _hoisted_3 = { class: "tir-pm-multiselect__label" }
const _hoisted_4 = { class: "tir-pm-multiselect__placeholder" }
const _hoisted_5 = {
  key: 1,
  class: "tir-pm-multiselect__area-right-slot"
}
const _hoisted_6 = { class: "tir-pm-multiselect__icon-open" }
const _hoisted_7 = { class: "tir-pm-multiselect__popover-content" }
const _hoisted_8 = { class: "tir-pm-multiselect__magnifying-glass-icon" }
const _hoisted_9 = { class: "tir-pm-multiselect__selected-list-inner" }
const _hoisted_10 = {
  key: 0,
  class: "tir-pm-multiselect__option-list"
}
const _hoisted_11 = { class: "tir-pm-multiselect__option-list-li" }

import {
  computed,
  ref,
  useSlots,
  PropType,
} from "vue";
import { ChevronDownIcon } from "tir-style-system/icons/solid";
import { MagnifyingGlassIcon } from "tir-style-system/icons/outline";
import {
  TirPmPopover,
  PopoverPositionEnum,
  PopoverPositionType,
} from "tir-pm-popover";
import { TirPmScrollbar } from "tir-pm-scrollbar";
import { TirPmMultiselectSizeEnum } from "./enums";
import { ITirPmMultiselectOption } from "./interfaces";
import { TirPmInput } from "tir-pm-input";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmMultiselect',
  props: {
  /**Выбранные опции */
  selectedOptions: {
    type: Array as PropType<Array<T>>,
    default: [],
  },
  /**Опции */
  options: {
    type: Array as PropType<Array<T>>,
    default: [],
  },
  /**Высота скорлла для опций */
  optionListScrollHeight: {
    type: String,
    default: "12rem",
  },
  /**Размер */
  size: {
    type: String as PropType<TirPmMultiselectSizeEnum>,
    default: TirPmMultiselectSizeEnum.Regular,
  },
  /**Лейбл */
  label: {
    type: String,
    default: "Label",
  },
  /**Плейсхолдер */
  placeholder: {
    type: String,
  },
  /**Дизейбл */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Состояние ошибки */
  isWithError: {
    type: Boolean,
    default: false,
  },
  /**Подсказка */
  hintMessage: {
    type: String,
    default: "",
  },
  /**Показывать ли подсказку */
  isShowHintMessage: {
    type: Boolean,
    default: false,
  },
  /**Позиция поповера */
  popoverPosition: {
    type: [String, Object] as PropType<
      PopoverPositionEnum | PopoverPositionType
    >,
    default: (): PopoverPositionType => ({
      top: "0.75rem + $el:height",
      left: "0rem",
    }),
  },
  /**Ширина поповера */
  popoverWidth: {
    type: String,
    default: "auto",
  },
  /**Классы для поповера */
  popoverClasses: {
    type: String,
  },
  /**Отключить поповер */
  isDisabledPopover: {
    type: Boolean,
    default: false,
  },
  /**Лейбл для инпута поиска */
  searchInputLabel: {
    type: String,
    default: "Поиск",
  },
  /**Плейсхолдер для инпута поиска */
  searchInputPlaceholder: {
    type: String,
  },
  /**
   * Включен локальный поиск в массиве.
   * Есть возможность отключить и использовать внешний поиск, например отправляя запросы к апи
   */
  isSearchLocal: {
    type: Boolean,
    default: true,
  },
  /**Скрыть поиск */
  isHiddenSearch: {
    type: Boolean,
    default: false,
  },
  /**Ширина */
  width: {
    type: String,
    default: "fit-content",
  },
  /**Не телепортировать */
  noTeleport: {
    type: Boolean,
    default: false,
  },
  /**Автофокус на инпуте поиска */
  searchInputAutofocus: {
    type: Boolean,
    default: false,
  },
  /**Отключение потери фокуса при клике по контенту */
  disableContentBlur: {
    type: Boolean,
    default: false,
  },
  /**Статичная высота скролл списка */
  staticScrollHeight: { type: Boolean },
  /**Отображении линии при наведении */
  showOnHover: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onOpen", "onClose", "onSearchEnter", "updateSearch", "onScroll"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Слоты */
const slots = useSlots();
/**Контент выбран */
const isSelectedContent = computed(
  () => slots && slots.selectedContent && slots.selectedContent()
);
/**Есть ли сло слева */
const isLeftSlot = computed(() => slots && slots.left && slots.left());
/**Есть ли слот справа */
const isRightSlot = computed(() => slots && slots.right && slots.right());
/**Стили скролла */
const scrollbarStyle = computed(() => {
  const style = { maxHeight: props.optionListScrollHeight } as any;
  if (props.staticScrollHeight) {
    style.minHeight = props.optionListScrollHeight;
  }
  return style;
});

/**Ссылка на элемент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();
/**Открыт ли поповер */
const isOpened = ref<boolean>(false);
/**При открытии поповера */
const onOpenPopover = () => {
  isOpened.value = true;
  emit("onOpen");
};
/**При закрытии поповера */
const onClosePopover = () => {
  isOpened.value = false;
  searchValue.value = "";
  emit("onClose");
};
/**Открыть поповер */
const openPopover = () => {
  $popover.value?.open();
};
/**Закрыть поповер */
const closePopover = () => {
  $popover.value?.close();
};

/**Обновить поповер */
const updatePopover = () => {
  $popover.value?.init();
};

/**Включен ли поиск */
const isEnabledSearch = computed(
  () =>
    (!props.isSearchLocal || props.options.some((option) => option.search)) &&
    !props.isHiddenSearch
);
/**Строка поиска */
const searchValue = ref("");
/**Функция обновления строки поиска */
const onUpdateSearchValue = (value: string) => {
  searchValue.value = value;
  emit("updateSearch", value);
};

/**Видимые опции */
const viewOptions = computed(() => {
  let options = props.options.filter((option) => !getIsSelectedOption(option));
  if (props.isSearchLocal && isEnabledSearch.value)
    options = options.filter(
      (option) => !option.search || option.search(searchValue.value)
    );

  return options;
});

/**Проверить выбранна ли опция */
const getIsSelectedOption = (option: ITirPmMultiselectOption) =>
  props.selectedOptions.some(
    (selectedOption) => selectedOption.Id === option.Id
  );

__expose({
  open: openPopover,
  close: closePopover,
  updatePopover,
  searchValue,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tir-pm-multiselect", {
      'tir-pm-multiselect--selected': isSelectedContent.value,
      'tir-pm-multiselect--opened': isOpened.value,
      'tir-pm-multiselect--with-hint': props.hintMessage,
      'tir-pm-multiselect--error': __props.isWithError,
      'tir-pm-multiselect--disabled': __props.isDisabled,
      'tir-pm-multiselect--regular': __props.size === _unref(TirPmMultiselectSizeEnum).Regular,
    }])
  }, [
    _createVNode(_unref(TirPmPopover), {
      ref_key: "$popover",
      ref: $popover,
      "is-disabled": __props.isDisabledPopover || __props.isDisabled,
      position: 
        typeof __props.popoverPosition === 'string' ? __props.popoverPosition : undefined
      ,
      "custom-position": 
        typeof __props.popoverPosition === 'object' ? __props.popoverPosition : undefined
      ,
      classes: __props.popoverClasses,
      width: __props.popoverWidth,
      "is-no-teleport": __props.noTeleport,
      "disable-content-blur": __props.disableContentBlur,
      onOpen: onOpenPopover,
      onClose: onClosePopover
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (isEnabledSearch.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
              'tir-pm-multiselect__search-input-section',
              { 'is-empty-list': !viewOptions.value.length },
            ])
              }, [
                _createVNode(_unref(TirPmInput), {
                  class: "tir-pm-multiselect__search-input",
                  placeholder: __props.searchInputPlaceholder,
                  label: __props.searchInputLabel,
                  "is-with-hint": false,
                  "is-small-size": "",
                  "model-value": searchValue.value,
                  "auto-focus": __props.searchInputAutofocus,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                (value) => onUpdateSearchValue(value?.toString())
              ),
                  onEnter: _cache[1] || (_cache[1] = ($event: any) => (emit('onSearchEnter')))
                }, {
                  leftInputAddons: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_unref(MagnifyingGlassIcon))
                    ])
                  ]),
                  _: 1
                }, 8, ["placeholder", "label", "model-value", "auto-focus"]),
                _renderSlot(_ctx.$slots, "rightInputAddons", { class: "tir-pm-multiselect__right-input-addons" })
              ], 2))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "optionsContent", {}, () => [
            _createElementVNode("div", {
              class: "tir-pm-multiselect__selected-list",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
            }, [
              _renderSlot(_ctx.$slots, "customSelectedContent", {
                selectedOptions: __props.selectedOptions,
                inPopover: true
              }, () => [
                _createElementVNode("div", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "selectedContent", {
                    selectedOptions: __props.selectedOptions,
                    inPopover: true
                  })
                ])
              ])
            ]),
            (__props.options.length || (__props.options && __props.staticScrollHeight))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_unref(TirPmScrollbar), {
                    style: _normalizeStyle(scrollbarStyle.value),
                    onOnScroll: _cache[4] || (_cache[4] = ($event: any) => (emit('onScroll', $event))),
                    showOnHover: __props.showOnHover
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "tir-pm-multiselect__option-list-inner",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: option.Id
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _renderSlot(_ctx.$slots, "optionList", {
                                option: option,
                                searchValue: searchValue.value
                              })
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 3
                  }, 8, ["style", "showOnHover"]),
                  _renderSlot(_ctx.$slots, "optionListBottom")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "target", { isOpened: isOpened.value }, () => [
          _createElementVNode("div", {
            class: "tir-pm-multiselect__area",
            style: _normalizeStyle({ width: __props.width })
          }, [
            (isLeftSlot.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "left")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["tir-pm-multiselect__selected-item", {
                'tir-pm-multiselect__selected-item--show':
                  isOpened.value || isSelectedContent.value,
              }])
              }, [
                _renderSlot(_ctx.$slots, "selectedContent", {}, () => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(__props.placeholder), 1)
                ])
              ], 2)
            ]),
            (isRightSlot.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "right")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ChevronDownIcon))
            ])
          ], 4)
        ])
      ]),
      _: 3
    }, 8, ["is-disabled", "position", "custom-position", "classes", "width", "is-no-teleport", "disable-content-blur"]),
    _createElementVNode("div", {
      class: _normalizeClass(["tir-pm-multiselect__hint-massage", {
        'tir-pm-multiselect__hint-massage--show':
          __props.isShowHintMessage && !isOpened.value,
      }])
    }, _toDisplayString(__props.hintMessage), 3)
  ], 2))
}
}

})